import { createFileRoute } from '@tanstack/react-router';
import { AttendanceRemindersPage } from '@/features/attendance/AttendanceRemindersPage';

/**
 * Promemoria delle timbrature mancate — configurazione per azienda (le sei chiavi di
 * `BE-RESPONSE-TO-FE-ATTENDANCE-MISSED-PUNCH-REMINDER-v1` §1.3) e registro delle decisioni del
 * job (`erp-attendance-reminders`, in sola lettura).
 *
 * Il modulo nasce **spento** su ogni azienda: questa pagina è il posto da cui si accende, e
 * l'unico da cui si può rispondere a «perché oggi non mi è arrivato niente».
 */
export const Route = createFileRoute('/_app/admin/attendance-reminders')({ component: AttendanceRemindersPage });
